<template>
    <b-row class="mb-3">
        <b-col md="6">
            <b-row>
                <b-col md="8">
                    <p class="head-text">Sales by Tech</p>
                </b-col>
                <b-col md="4">
                    <eb-select
                        id="selectedDate1"
                        type="text"
                        label="text"
                        v-model="selectedDate1"
                        :selected="selectedDate1.text"
                        @input="changeDate1"
                        :options="dateOption"
                    ></eb-select>
                    <c-date
                        ref="compRefs1"
                        modalRef="modalRef1"
                        modalId="dateModal1"
                        @customDateRange="findDateResult1"
                    ></c-date>
                </b-col>
            </b-row>
            <b-card>
                <div
                    v-if="
                        chartData && chartData.labels && chartData.labels.length
                    "
                >
                    <BarChart
                        :chart-data="chartData"
                        :chart-options="barChartOptions"
                    />
                </div>
            </b-card>
        </b-col>
        <b-col md="6">
            <b-row>
                <b-col md="8">
                    <p class="head-text">Sales by Region</p>
                </b-col>
                <b-col md="4">
                    <eb-select
                        id="selectedDate2"
                        type="text"
                        label="text"
                        v-model="selectedDate2"
                        :selected="selectedDate2.text"
                        @input="changeDate2"
                        :options="dateOption"
                    ></eb-select>
                    <c-date
                        ref="compRefs2"
                        modalRef="modalRef2"
                        modalId="dateModal2"
                        @customDateRange="findDateResult2"
                    ></c-date>
                </b-col>
            </b-row>
            <b-card>
                <div
                    v-if="
                        chartData1 &&
                        chartData1.labels &&
                        chartData1.labels.length
                    "
                >
                    <BarChart
                        :chart-data="chartData1"
                        :chart-options="barChartOptions1"
                    />
                </div>
            </b-card>
        </b-col>
        <b-col md="6">
            <b-row>
                <b-col md="8">
                    <p class="head-text">
                        Hours per by Tech Straight vs Overtime
                    </p>
                </b-col>
                <b-col md="4">
                    <eb-select
                        id="selectedDate3"
                        type="text"
                        label="text"
                        v-model="selectedDate3"
                        :selected="selectedDate3.text"
                        @input="changeDate3"
                        :options="dateOption"
                    ></eb-select>
                    <c-date
                        ref="compRefs3"
                        modalRef="modalRef3"
                        modalId="dateModal3"
                        @customDateRange="findDateResult3"
                    ></c-date>
                </b-col>
            </b-row>
            <b-card>
                <div
                    v-if="
                        chartData2 &&
                        chartData2.labels &&
                        chartData2.labels.length
                    "
                >
                    <BarChart
                        :chart-data="chartData2"
                        :chart-options="barChartOptions2"
                    />
                </div>
            </b-card>
        </b-col>
        <b-col md="6">
            <b-row>
                <b-col md="8">
                    <p class="head-text">Margin by Tech</p>
                </b-col>
                <b-col md="4">
                    <eb-select
                        id="selectedDate4"
                        type="text"
                        label="text"
                        v-model="selectedDate4"
                        :selected="selectedDate4.text"
                        @input="changeDate4"
                        :options="dateOption"
                    ></eb-select>
                    <c-date
                        ref="compRefs4"
                        modalRef="modalRef4"
                        modalId="dateModal4"
                        @customDateRange="findDateResult4"
                    ></c-date>
                </b-col>
            </b-row>
            <b-card>
                <div
                    v-if="
                        chartData3 &&
                        chartData3.labels &&
                        chartData3.labels.length
                    "
                >
                    <BarChart
                        :chart-data="chartData3"
                        :chart-options="barChartOptions3"
                    />
                </div>
            </b-card>
        </b-col>
        <b-col md="6">
            <b-row>
                <b-col md="8">
                    <p class="head-text">Number of Tickets</p>
                </b-col>
                <b-col md="4">
                    <eb-select
                        id="selectedDate5"
                        type="text"
                        label="text"
                        v-model="selectedDate5"
                        :selected="selectedDate5.text"
                        @input="changeDate5"
                        :options="dateOption"
                    ></eb-select>
                    <c-date
                        ref="compRefs5"
                        modalRef="modalRef5"
                        modalId="dateModal5"
                        @customDateRange="findDateResult5"
                    ></c-date>
                </b-col>
            </b-row>
            <b-card>
                <div
                    v-if="
                        chartData4 &&
                        chartData4.labels &&
                        chartData4.labels.length
                    "
                >
                    <BarChart
                        :chart-data="chartData4"
                        :chart-options="barChartOptions4"
                    />
                </div>
            </b-card>
        </b-col>
        <b-col md="6">
            <b-row>
                <b-col md="6">
                    <p class="head-text">Same Time Previous Year</p>
                </b-col>

                <b-col md="3">
                    <eb-select
                        type="select"
                        v-model="selectedCustomer"
                        :options="customerList"
                        label="text"
                        :id="'selectCustomer'"
                        @input="changeCustomer"
                        :selected="selectedCustomer"
                    ></eb-select>
                </b-col>
                <b-col md="3">
                    <eb-select
                        id="selectedDate6"
                        type="text"
                        label="text"
                        v-model="selectedDate6"
                        :selected="selectedDate6.text"
                        @input="changeDate6"
                        :options="dateOption"
                    ></eb-select>
                    <c-date
                        ref="compRefs6"
                        modalRef="modalRef6"
                        modalId="dateModal6"
                        @customDateRange="findDateResult6"
                    ></c-date>
                </b-col>
            </b-row>
            <b-card>
                <div
                    v-if="
                        chartData5 &&
                        chartData5.labels &&
                        chartData5.labels.length
                    "
                >
                    <BarChart
                        :chart-data="chartData5"
                        :chart-options="barChartOptions5"
                    />
                </div>
            </b-card>
        </b-col>
        <b-col md="6">
            <b-row>
                <b-col md="6">
                    <p class="head-text">Jobs by ticket size</p>
                </b-col>
                <b-col md="3">
                    <eb-select
                        type="select"
                        v-model="selectedCustomer1"
                        :options="customerList1"
                        label="text"
                        :id="'selectCustomer1'"
                        @input="changeCustomer1"
                        :selected="selectedCustomer1"
                    ></eb-select>
                </b-col>
                <b-col md="3">
                    <eb-select
                        id="selectedDate7"
                        type="text"
                        label="text"
                        v-model="selectedDate7"
                        :selected="selectedDate7.text"
                        @input="changeDate7"
                        :options="dateOption"
                    ></eb-select>
                    <c-date
                        ref="compRefs7"
                        modalRef="modalRef7"
                        modalId="dateModal7"
                        @customDateRange="findDateResult7"
                    ></c-date>
                </b-col>
            </b-row>
            <b-card>
                <div
                    v-if="
                        chartData6 &&
                        chartData6.labels &&
                        chartData6.labels.length
                    "
                >
                    <BarChart
                        :chart-data="chartData6"
                        :chart-options="barChartOptions6"
                    />
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
import cDate from "@/components/FormElements/CustomDate.vue";
import BarChart from "@/components/chart/newBarChart.vue";
import moment from "moment";

export default {
    name: "Reports",
    components: { ebSelect, cDate, BarChart },
    data() {
        return {
            selectedCustomer: "All",
            selectedCustomer1: "All",
            selectedDate1: {
                text: "7 days",
                value: 6,
            },
            selectedDate2: {
                text: "7 days",
                value: 6,
            },
            selectedDate3: {
                text: "7 days",
                value: 6,
            },
            selectedDate4: {
                text: "7 days",
                value: 6,
            },
            selectedDate5: {
                text: "7 days",
                value: 6,
            },
            selectedDate6: {
                text: "7 days",
                value: 6,
            },
            selectedDate7: {
                text: "7 days",
                value: 6,
            },
            dateOption: [
                {
                    text: "Today",
                    value: 0,
                },
                {
                    text: "7 days",
                    value: 6,
                },
                {
                    text: "30 days",
                    value: 29,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate1: "",
            endDate1: "",
            startDate2: "",
            endDate2: "",
            startDate3: "",
            endDate3: "",
            startDate4: "",
            endDate4: "",
            startDate5: "",
            endDate5: "",
            startDate6: "",
            endDate6: "",
            startDate7: "",
            endDate7: "",
        };
    },
    computed: {
        chartData() {
            const dataList = this.$store.getters["partner/getSalesByTech"];
            const labels = [];
            const dataSets = [
                {
                    label: "Total Sales",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                },
                {
                    label: "Total Technicians",
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    data: [],
                },
            ];

            if (dataList && dataList["sales-by-tech"]) {
                if (dataList["sales-by-tech"].length > 0) {
                    dataList["sales-by-tech"].map((el) => {
                        labels.push(el.Tech_Name);
                        dataSets[0].data.push(parseInt(el.total_sales));
                        dataSets[1].data.push(parseInt(el.total_tech));
                    });
                }
            }

            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        beginAtZero: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    x: {
                        display: true,
                        ticks: {
                            display: true,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
            };
        },
        chartData1() {
            const dataList = this.$store.getters["partner/getSalesByRegion"];
            const labels = [];
            const dataSets = [
                {
                    label: "Customer Region",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                },
                {
                    label: "Total Customer",
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    data: [],
                },
            ];

            if (dataList && dataList["sales-by-region"]) {
                if (dataList["sales-by-region"].length > 0) {
                    dataList["sales-by-region"].map((el) => {
                        labels.push(el["Customer Region"]);
                        dataSets[0].data.push(parseInt(el.total_customer));
                        dataSets[1].data.push(parseInt(el.total_sales));
                    });
                }
            }

            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions1() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        beginAtZero: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    x: {
                        display: true,
                        ticks: {
                            display: true,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
            };
        },
        chartData2() {
            const dataList =
                this.$store.getters["partner/gethoursTechStraightOvertime"];
            const labels = [];
            const dataSets = [
                {
                    label: "Total Overtime Hours",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                },
                {
                    label: "Total Straight Hours",
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    data: [],
                },
            ];

            if (
                dataList &&
                dataList["Hours-per-by-Tech - Straight vs Overtime"]
            ) {
                if (
                    dataList["Hours-per-by-Tech - Straight vs Overtime"]
                        .length > 0
                ) {
                    dataList["Hours-per-by-Tech - Straight vs Overtime"].map(
                        (el) => {
                            labels.push(el.Tech_Name);
                            dataSets[0].data.push(
                                parseInt(el.total_overtime_hours)
                            );
                            dataSets[1].data.push(
                                parseInt(el.total_straight_hours)
                            );
                        }
                    );
                }
            }

            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions2() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        beginAtZero: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    x: {
                        display: true,
                        ticks: {
                            display: true,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
            };
        },
        chartData3() {
            const dataList =
                this.$store.getters["partner/getNumberOfMarginByTech"];
            const labels = [];
            const dataSets = [
                {
                    label: "Total Cost",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                },
                {
                    label: "Total Revenue",
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    data: [],
                },
                {
                    label: "Margin",
                    backgroundColor: "#2554FF",
                    data: [],
                },
            ];

            if (dataList && dataList["no-of-margin-by-tech"]) {
                if (dataList["no-of-margin-by-tech"].length > 0) {
                    dataList["no-of-margin-by-tech"].map((el) => {
                        labels.push(el.Tech_Name);
                        dataSets[0].data.push(parseInt(el.total_cost));
                        dataSets[1].data.push(parseInt(el.total_revenue));
                        dataSets[2].data.push(parseInt(el.margin));
                    });
                }
            }

            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions3() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        beginAtZero: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    x: {
                        display: true,
                        ticks: {
                            display: true,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
            };
        },
        chartData4() {
            const dataList = this.$store.getters["partner/getNumberOfTickets"];
            const labels = [];
            const dataSets = [
                {
                    label: "Closed Tickets",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                },
                {
                    label: "Opened Tickets",
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    data: [],
                },
                {
                    label: "Total Tickets",
                    backgroundColor: "#2554FF",
                    data: [],
                },
                {
                    label: "Wip Tickets",
                    backgroundColor: "#59e8f0",
                    data: [],
                },
            ];

            if (dataList && dataList["number-of-tickets"]) {
                if (dataList["number-of-tickets"].length > 0) {
                    dataList["number-of-tickets"].map((el) => {
                        labels.push(el.Customer_Name);
                        dataSets[0].data.push(parseInt(el.closed_tickets));
                        dataSets[1].data.push(parseInt(el.opened_tickets));
                        dataSets[2].data.push(parseInt(el.total_tickets));
                        dataSets[3].data.push(parseInt(el.wip_tickets));
                    });
                }
            }

            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions4() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        beginAtZero: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    x: {
                        display: true,
                        ticks: {
                            display: true,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
            };
        },
        chartData5() {
            const dataList =
                this.$store.getters["partner/getSameTimePreviousYear"];
            const labels = [];
            const dataSets = [
                {
                    label: "Ticket Count",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                },
                {
                    label: "Total Ticket Value",
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    data: [],
                },
            ];

            if (dataList && dataList["Same-time-previous-year"]) {
                if (dataList["Same-time-previous-year"].length > 0) {
                    dataList["Same-time-previous-year"].map((el) => {
                        labels.push(`${el.Customer_Name} - ${el.year}`);
                        dataSets[0].data.push(parseInt(el.ticket_count));
                        dataSets[1].data.push(parseInt(el.total_ticket_value));
                    });
                }
            }

            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions5() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        beginAtZero: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    x: {
                        display: true,
                        ticks: {
                            display: true,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
            };
        },
        customerList() {
            let data = this.$store.getters["partner/getSameTimePreviousYear"];
            // const customerDataList = data["Same-time-previous-year"].map(
            //     (d) => {
            //         return {
            //             text: d.Customer_Name,
            //             value: d.Customer_Name,
            //         };
            //     }
            // );
            const customerDataList = data["Same-time-previous-year"]
                ? data["Same-time-previous-year"].map((d) => {
                      return {
                          text: d.Customer_Name,
                          value: d.Customer_Name,
                      };
                  })
                : [];
            customerDataList.unshift({ text: "All", value: "all" });
            return customerDataList;
        },
        chartData6() {
            const dataList =
                this.$store.getters["partner/getNumberOfJobsByTicketSize"];
            console.log(dataList, "datalist");
            const labels = [];
            const dataSets = [
                {
                    label: "Num of Jobs",
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                    data: [],
                },
                {
                    label: "Ticket Size",
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                    data: [],
                },
            ];

            if (dataList && dataList["Number-of-jobs-by-ticket-size"]) {
                if (dataList["Number-of-jobs-by-ticket-size"].length > 0) {
                    dataList["Number-of-jobs-by-ticket-size"].map((el) => {
                        labels.push(el.Customer_Name);
                        dataSets[0].data.push(parseInt(el.num_of_jobs));
                        dataSets[1].data.push(parseInt(el.ticket_size));
                    });
                }
            }

            return {
                labels,
                datasets: dataSets,
            };
        },
        barChartOptions6() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    y: {
                        display: true,
                        beginAtZero: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    x: {
                        display: true,
                        ticks: {
                            display: true,
                        },
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                },
            };
        },
        customerList1() {
            let data =
                this.$store.getters["partner/getNumberOfJobsByTicketSize"];
            const customerDataList1 = data["Number-of-jobs-by-ticket-size"]
                ? data["Number-of-jobs-by-ticket-size"].map((d) => {
                      return {
                          text: d.Customer_Name,
                          value: d.Customer_Name,
                      };
                  })
                : [];
            customerDataList1.unshift({ text: "All", value: "all" });
            return customerDataList1;
        },
    },
    methods: {
        changeDate1(e) {
            this.selectedDate1 = e;
            if (e.value == "custom") {
                this.$refs["compRefs1"].openModal();
                return;
            }
            this.fetchSalesByTechData();
        },
        findDateResult1(e) {
            this.startDate1 = e.fromDate;
            this.endDate1 = e.toDate;
            this.fetchSalesByTechData();
        },

        getDateData1(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate1,
                    toDate: this.endDate1,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchSalesByTechData() {
            const data = [
                {
                    key: "sales-by-tech",
                    variables: {
                        // fromDate: "2025-01-30",
                        // toDate: "2025-01-30",
                        ...this.getDateData1(this.selectedDate1.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNumnerSalesTech", {
                items: data,
            });
        },
        changeDate2(e) {
            this.selectedDate2 = e;
            if (e.value == "custom") {
                this.$refs["compRefs2"].openModal();
                return;
            }
            this.fetchSalesByRegionData();
        },
        findDateResult2(e) {
            this.startDate2 = e.fromDate;
            this.endDate2 = e.toDate;
            this.fetchSalesByRegionData();
        },

        getDateData2(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate2,
                    toDate: this.endDate2,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchSalesByRegionData() {
            const data = [
                {
                    key: "sales-by-region",
                    variables: {
                        // fromDate: "2025-01-30",
                        // toDate: "2025-01-30",
                        ...this.getDateData2(this.selectedDate2.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNumnerSalesRegion", {
                items: data,
            });
        },
        changeDate3(e) {
            this.selectedDate3 = e;
            if (e.value == "custom") {
                this.$refs["compRefs3"].openModal();
                return;
            }
            this.fetchHoursTechStraightOvertime();
        },
        findDateResult3(e) {
            this.startDate3 = e.fromDate;
            this.endDate3 = e.toDate;
            this.fetchHoursTechStraightOvertime();
        },

        getDateData3(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate3,
                    toDate: this.endDate3,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchHoursTechStraightOvertime() {
            const data = [
                {
                    key: "Hours-per-by-Tech - Straight vs Overtime",
                    variables: {
                        // fromDate: "2025-01-30",
                        // toDate: "2025-01-30",
                        ...this.getDateData3(this.selectedDate3.value),
                    },
                },
            ];
            await this.$store.dispatch(
                "partner/fetchHoursTechStraightOvertime",
                {
                    items: data,
                }
            );
        },
        changeDate4(e) {
            this.selectedDate4 = e;
            if (e.value == "custom") {
                this.$refs["compRefs4"].openModal();
                return;
            }
            this.fetchNumberMarginByTech();
        },
        findDateResult4(e) {
            this.startDate4 = e.fromDate;
            this.endDate4 = e.toDate;
            this.fetchNumberMarginByTech();
        },

        getDateData4(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate4,
                    toDate: this.endDate4,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchNumberMarginByTech() {
            const data = [
                {
                    key: "no-of-margin-by-tech",
                    variables: {
                        // fromDate: "2025-01-30",
                        // toDate: "2025-01-30",
                        ...this.getDateData4(this.selectedDate4.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNumberOfMarginByTech", {
                items: data,
            });
        },
        changeDate5(e) {
            this.selectedDate5 = e;
            if (e.value == "custom") {
                this.$refs["compRefs5"].openModal();
                return;
            }
            this.fetchfetchNumberTickets();
        },
        findDateResult5(e) {
            this.startDate5 = e.fromDate;
            this.endDate5 = e.toDate;
            this.fetchfetchNumberTickets();
        },

        getDateData5(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate5,
                    toDate: this.endDate5,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchfetchNumberTickets() {
            const data = [
                {
                    key: "number-of-tickets",
                    variables: {
                        // fromDate: "2025-01-30",
                        // toDate: "2025-01-30",
                        ...this.getDateData5(this.selectedDate5.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchNumberOfTickets", {
                items: data,
            });
        },
        changeDate6(e) {
            this.selectedDate6 = e;
            if (e.value == "custom") {
                this.$refs["compRefs6"].openModal();
                return;
            }
            this.fetchSameTimePreviousYear();
        },
        findDateResult6(e) {
            this.startDate6 = e.fromDate;
            this.endDate6 = e.toDate;
            this.fetchSameTimePreviousYear();
        },

        getDateData6(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate6,
                    toDate: this.endDate6,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchSameTimePreviousYear() {
            const data = [
                {
                    key: "Same-time-previous-year",
                    variables: {
                        // fromDate: "2025-01-30",
                        // toDate: "2025-01-30",
                        ...this.getDateData6(this.selectedDate6.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchSameTimePreviousYear", {
                items: data,
            });
        },
        async changeCustomer(selected) {
            if (selected.value === "all") {
                await this.fetchSameTimePreviousYear();
                return;
            } else await this.fetchCustomerSameTimePreviousYear(selected);
        },
        async fetchCustomerSameTimePreviousYear(customerName) {
            if (!customerName || !customerName.text) {
                console.error("Invalid customer name:", customerName);
                return;
            }
            const data = [
                {
                    key: "customer-same-time-previous-year",
                    variables: {
                        // fromDate: "2025-01-30",
                        // toDate: "2025-01-30",
                        ...this.getDateData6(this.selectedDate6.value),
                        Customer: customerName.text,
                    },
                },
            ];
            await this.$store.dispatch(
                "partner/fetchCustomerSameTimePreviousYear",
                {
                    items: data,
                }
            );
        },
        changeDate7(e) {
            this.selectedDate7 = e;
            if (e.value == "custom") {
                this.$refs["compRefs7"].openModal();
                return;
            }
            this.fetchNumberJobsByTicketSize();
        },
        findDateResult7(e) {
            this.startDate7 = e.fromDate;
            this.endDate7 = e.toDate;
            this.fetchNumberJobsByTicketSize();
        },

        getDateData7(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate7,
                    toDate: this.endDate7,
                };
                return data;
            }
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(1, "days").format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        async fetchNumberJobsByTicketSize() {
            const data = [
                {
                    key: "Number-of-jobs-by-ticket-size",
                    variables: {
                        // fromDate: "2025-01-30",
                        // toDate: "2025-01-30",
                        ...this.getDateData7(this.selectedDate7.value),
                    },
                },
            ];
            await this.$store.dispatch(
                "partner/fetchNumberOfJobsByTicketSize",
                {
                    items: data,
                }
            );
        },
        async changeCustomer1(selected) {
            if (selected.value === "all") {
                await this.fetchNumberJobsByTicketSize();
                return;
            } else await this.fetchCustomerNumberJobsByTicketSize(selected);
        },
        async fetchCustomerNumberJobsByTicketSize(customerName) {
            if (!customerName || !customerName.text) {
                console.error("Invalid customer name:", customerName);
                return;
            }
            const data = [
                {
                    key: "customer-Number-of-jobs-by-ticket-size",
                    variables: {
                        // fromDate: "2025-01-30",
                        // toDate: "2025-01-30",
                        ...this.getDateData7(this.selectedDate7.value),
                        Customer: customerName.text,
                    },
                },
            ];
            await this.$store.dispatch(
                "partner/fetchCustomerNumberOfJobsByTicketSize",
                {
                    items: data,
                }
            );
        },
    },
    async mounted() {
        await this.fetchSalesByTechData();
        await this.fetchSalesByRegionData();
        await this.fetchNumberJobsByTicketSize();
        await this.fetchCustomerNumberJobsByTicketSize();
        await this.fetchHoursTechStraightOvertime();
        await this.fetchNumberMarginByTech();
        await this.fetchfetchNumberTickets();
        await this.fetchSameTimePreviousYear();
        await this.fetchCustomerSameTimePreviousYear();
    },
};
</script>
